import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";

import Menu from '@material-ui/core/Menu';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import { t } from './common/LocalizationProvider';
import {devicesSelectedActions} from "./store";
import ConfirmHandler from "./shared/ConfirmHandler";
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const EditCollectionView = ({ content, editPath, endpoint, disableAdd }) => {
  const classes = useStyles();
  const history = useHistory();
  const subadminEnabled = useSelector(state => state.session.user && state.session.user.subadmin);
  const dispatch = useDispatch();

  const [selectedId, setSelectedId] = useState(null);
  const [selectedAnchorEl, setSelectedAnchorEl] = useState(null);
  const [removeDialogShown, setRemoveDialogShown] = useState(false);
  const [updateTimestamp, setUpdateTimestamp] = useState(Date.now());

  const menuShow = (anchorId, itemId) => {
    setSelectedAnchorEl(anchorId);
    setSelectedId(itemId);
  }

  const menuHide = () => {
    setSelectedAnchorEl(null);
  }

  const handleAdd = () => {
    history.push(editPath);
    menuHide();
  }

  const handleEdit = () => {
    history.push(`${editPath}/${selectedId}`);
    menuHide();
  }

  const handleRemove = () => {
    setRemoveDialogShown(true);
    menuHide();
  }

  const handleRemoveResult = () => {
    setRemoveDialogShown(false);
    setUpdateTimestamp(Date.now());
  }

  const handleDevices = () => {
    dispatch(devicesSelectedActions.updateDevicesSelected([]));
    history.push(`devicesInfo/${selectedId}`);
    menuHide();
  }

  const Content = content;

  return (
      <>
        <Content updateTimestamp={updateTimestamp} onMenuClick={menuShow}/>
        {!disableAdd &&
            <Fab size="medium" className={classes.fab} onClick={handleAdd}>
              <AddIcon />
            </Fab>
        }
        <Menu
            className={classes.menu}
            open={!!selectedAnchorEl}
            anchorEl={selectedAnchorEl}
            onClose={menuHide}
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
        >
          <MenuItem className={classes.menuItem} onClick={handleEdit}>
            {t('sharedEdit')}
          </MenuItem>
          {editPath === "/user" && subadminEnabled && (
              <MenuItem className={classes.menuItem} onClick={handleDevices}>
                {t('deviceTitle')}
              </MenuItem>
          )}
          <MenuItem
              className={classes.menuItem}
              onClick={handleRemove}
              style={{ color: '#ff4d4d' }} // Red warning for removal
          >
            {t('sharedRemove')}
          </MenuItem>
        </Menu>

        <ConfirmHandler
            open={removeDialogShown}
            endpoint={endpoint}
            itemId={selectedId}
            handleCloseDialog={handleRemoveResult}
        />
      </>
  );
}

export default EditCollectionView;